import React from 'react'
import { Typography, Button, Snackbar } from '@material-ui/core'
import logo from '../../../images/person.svg'
import success from '../../../images/success.svg'
import question from '../../../images/question.svg'
import cancel from '../../../images/cancel.svg'
import error from '../../../images/error.svg'
import {LOCALSTORAGE_KEYS} from "../../../utils/constants";
const style = {
   submitNotRegistred: {
      marginTop: '10px',
      textTransform: 'none',
      width: '45%',
      marginLeft: '5px',
      marginRight: '5px'
   },
   exitButton: {
      margin: '5px',
      textTransform: 'none',
      width: '45%'
   },
   acceptButton: {
      margin: '5px',
      textTransform: 'none',
      width: '45%'
   },
   cancelButton: {
      margin: '5px',
      textTransform: 'none',
      width: '95%',
      border: 'none'
   },
   cancelDialogButton: {
      margin: '5px',
      width: '35%',
      textTransform: 'none'
   },
   acceptDialogButton: {
      margin: '5px',
      width: '35%',
      textTransform: 'none'
   },
   titleOne: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '16px',
      textAlign: 'center',
      lineHeight: '28px',
      letterSpacing: '-0.06px'
   },
   messageUserisNotRegistredInfo: {
      'text-align': 'left'
   },
   messageUserisNotRegistred: {
      top: '270px',
      left: '336px',
      width: '331px',
      height: '101px',
      font: 'normal normal normal 15px/22px Roboto',
      color: '#8A8FAB',
      'text-align': 'center',
      'letter-spacing': '0px',
      opacity: '1'
   },
   dialogMessage: {
      marginLeft: '40px',
      width: '300px',
      height: '101px',
      font: 'normal normal normal 15px/22px Roboto',
      color: '#8A8FAB',
      'text-align': 'center',
      'letter-spacing': '0px',
      opacity: '1'
   },
   dialogContainer: {
      zIndex: 2,
      position: 'absolute',
      backgroundColor: '#e5e5e5',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
   },
   detailsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
   },
   buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap'
   },
   dialog: {
      width: '400px',
      height: '400px',
      backgroundColor: 'white'
   },
   isNotRegistered: {
      marginBottom: '30%'
   },
   isRegistered: {
      marginBottom: '30%'
   },
   logo: {
      width: '18%',
      height: 'auto',
      margin: 'auto'
   },
   dialogLogo: {
      width: '18%',
      height: 'auto',
      margin: 'auto',
      marginTop: '10px'
   },
   associateConfirmButton: {
      margin: '5px',
      textTransform: 'none',
      width: '45%'
   },
   associateNegationButton: {
      margin: '5px',
      textTransform: 'none',
      width: '45%'
   }
}

const query = new URLSearchParams(location.search)
const isUpdate = () => {
   return query.get('update') === '1'
}

const UserNotRegistered = props => {
   return (
      <div style={style.isNotRegistered}>
         <Typography style={style.titleOne}>
            <p>Usuario NO Registrado</p>
            <img alt="" src={logo} style={style.logo} />{' '}
         </Typography>
         <div>
            <div style={style.messageUserisNotRegistred}>
               Estimado usuario, agradecemos por contactarse con mutualser eps.
               En este momento no registra como empleador en nuestra base de
               datos.
            </div>
            <div style={style.messageUserisNotRegistred}>
               Por favor enviar a{' '}
               <span style={{ color: '#3264DC' }}>
                  {' '}
                  infocontributivo@mutualser.org{' '}
               </span>
               <ul style={style.messageUserisNotRegistredInfo}>
                  <li>Cámara de comercio</li>
                  <li>Certificación bancaria</li>
                  <li>RUT</li>
                  <li>
                     Fotocopia Documento de Identidad del Representante Legal
                  </li>
               </ul>
               <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={style.submitNotRegistred}
                  fullWidth
                  onClick={() => props.history.push('/')}
               >
                  ENTENDIDO
               </Button>
            </div>
         </div>
      </div>
   )
}

export const AssociateConfirmationMessage = ({
   associate,
   history,
   callback,
   token_app = localStorage.getItem(LOCALSTORAGE_KEYS.TOKEN_APP)
}) => {
   if (isUpdate()) {
      if (!associate.esImportado) {
         return associateRegistered({
            message:
               'Estimado usuario, no se encuentra habilitado para la actualización de sus datos, por favor escalar su caso a su gestor comunitario.',
            title: 'Usuario No Valido',
            confirmAction: () => {
               location.reload()
            },
            variant: 'outlined',
            logo: success
         })
      }
      if (associate.actualizado) {
         return associateRegistered({
            message:
               'Estimado asociado, ya sus datos se encuentran actualizados, por favor ingresar con sus credenciales al Portal Asociados',
            title: 'Usuario Actualizado',
            confirmAction: () => {
               history.push('/')
            },
            variant: 'outlined',
            logo: error
         })
      }
      window.location.href = `${process.env.REACT_APP_ASSOCIATE_EXTERNAL_FORMULARY}/#./actualizacion?tipoIdentificacion=${associate.tipoIdentificacion}&numeroIdentificacion=${associate.numeroIdentificacion}&tk=${token_app}`
   } else {
      switch (associate.estado) {
         case 'COMPLETADO':
            if (associate.estadoActividad === 'EXCLUIDO') {
               return associateRegistered({
                  message:
                     'Estimado usuario, su solicitud no puede ser procesada, dado que se encuentra en estado Excluido',
                  title: 'Usuario denegado',
                  confirmAction: () => {
                     history.push('/')
                  },
                  variant: 'outlined',
                  logo: error
               })
            }
            if (associate.estadoDeCuentaVigente === 'INADMISIBLE') {
               return associateRegistered({
                  message:
                     'Estimado usuario, su solicitud no puede ser procesada, dado el incumplimiento en el tiempo estipulado para el pago de su cuota de admisión',
                  title: 'Usuario denegado',
                  confirmAction: () => {
                     history.push('/')
                  },
                  variant: 'outlined',
                  logo: error
               })
            }
            if (associate.rol === 'ASOCIADO') {
               return associateRegistered({
                  message:
                     'Estimado usuario, se encuentra un registro en tramite para su gestión, en los próximos días recibirá un correo informándole el estado final de su solicitud para ser asociado de mutualser',
                  title: 'Usuario registrado',
                  confirmAction: () => {
                     history.push('/')
                  },
                  variant: 'contained',
                  logo: success
               })
            }
            return associateCollaboratorRegistered({
               message:
                  'Estimado usuario, se encuentra un registro como Colaborador con este número de documento de identidad. ¿Desea iniciar el proceso de actualización de sus datos?',
               title: 'Usuario registrado',
               cancelAction: () => {
                  history.push('/')
               },
               confirmAction: () => {
                  window.location.href = `${process.env.REACT_APP_ASSOCIATE_EXTERNAL_FORMULARY}/#./?tipoIdentificacion=${associate.tipoIdentificacion}&numeroIdentificacion=${associate.numeroIdentificacion}&rol=${associate.rol}&tk=${token_app}`
               },
               logo: success
            })

         case 'PENDIENTE':
            if (associate.rol === 'ASOCIADO') {
               return associatePartiallyRegistered({
                  message:
                     'Estimado usuario, se encuentra una solicitud pendiente por su finalización, ¿Desea continuar con su diligenciamiento?',
                  title: 'Formato Incompleto',
                  confirmAction: () => {
                     window.location.href = `${process.env.REACT_APP_ASSOCIATE_EXTERNAL_FORMULARY}/#./?tipoIdentificacion=${associate.tipoIdentificacion}&numeroIdentificacion=${associate.numeroIdentificacion}&rol=${associate.rol}&tk=${token_app}`
                  },
                  cancelAction: () => {
                     callback()
                  },
                  exitAction: () => {
                     history.push('/')
                  }
               })
            }
            return associateNotRegistered({
               title: 'Usuario No registrado',
               logo,
               message:
                  'Estimado usuario, no se encontraron resultados con este número de documento de Identidad. ¿Desea Iniciar el Proceso de registro como Colaborador?',
               confirmAction: () => {
                  window.location.href = `${process.env.REACT_APP_ASSOCIATE_EXTERNAL_FORMULARY}/#./?tipoIdentificacion=${associate.tipoIdentificacion}&numeroIdentificacion=${associate.numeroIdentificacion}&rol=${associate.rol}&tk=${token_app}`
               },
               cancelAction: () => {
                  history.push('/')
               }
            })

         default:
            return associateNotRegistered({
               title: 'Usuario No registrado',
               logo,
               message:
                  associate.rol === 'ASOCIADO'
                     ? 'Estimado usuario, no se encontraron resultados con este numero de documento de Identidad. ¿Desea iniciar el proceso de solicitud de admisión para Ser Asociado?'
                     : 'Estimado usuario, no se encontraron resultados con este número de documento de Identidad. ¿Desea Iniciar el Proceso de registro como Colaborador?',
               confirmAction: () => {
                  window.location.href = `${process.env.REACT_APP_ASSOCIATE_EXTERNAL_FORMULARY}/#./?tipoIdentificacion=${associate.tipoIdentificacion}&numeroIdentificacion=${associate.numeroIdentificacion}&rol=${associate.rol}&tk=${token_app}`
               },
               cancelAction: () => {
                  history.push('/')
               }
            })
      }
   }
}

const associateNotRegistered = ({
   message,
   title,
   logo,
   confirmAction,
   cancelAction
}) => {
   return (
      <div style={style.isNotRegistered}>
         <Typography style={style.titleOne}>
            <p> {title} </p>
            <img alt="" src={logo} style={style.logo} />{' '}
         </Typography>
         <div style={style.detailsContainer}>
            <div style={style.messageUserisNotRegistred}> {message} </div>
            <div style={style.buttonContainer}>
               <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={style.associateNegationButton}
                  fullWidth
                  onClick={() => cancelAction()}
               >
                  NO
               </Button>

               <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={style.associateConfirmButton}
                  fullWidth
                  onClick={() => confirmAction()}
               >
                  SI
               </Button>
            </div>
         </div>
      </div>
   )
}

const associateRegistered = ({
   message,
   title,
   logo,
   confirmAction,
   variant
}) => {
   return (
      <div style={style.isNotRegistered}>
         <Typography style={style.titleOne}>
            <p> {title} </p>
            <img alt="" src={logo} style={style.logo} />{' '}
         </Typography>
         <div style={style.detailsContainer}>
            <div style={style.messageUserisNotRegistred}> {message} </div>
            <div style={style.buttonContainer}>
               <Button
                  type="submit"
                  variant={variant}
                  color="primary"
                  style={style.submitNotRegistred}
                  fullWidth
                  onClick={() => confirmAction()}
               >
                  ENTENDIDO
               </Button>
            </div>
         </div>
      </div>
   )
}

const associateCollaboratorRegistered = ({
   message,
   title,
   logo,
   confirmAction,
   cancelAction
}) => {
   return (
      <div style={style.isNotRegistered}>
         <Typography style={style.titleOne}>
            <p> {title} </p>
            <img alt="" src={logo} style={style.logo} />{' '}
         </Typography>
         <div style={style.detailsContainer}>
            <div style={style.messageUserisNotRegistred}> {message} </div>
            <div style={style.buttonContainer}>
               <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={style.submitNotRegistred}
                  fullWidth
                  onClick={() => cancelAction()}
               >
                  NO
               </Button>

               <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={style.submitNotRegistred}
                  fullWidth
                  onClick={() => confirmAction()}
               >
                  SI
               </Button>
            </div>
         </div>
      </div>
   )
}

const associatePartiallyRegistered = ({
   message,
   title,
   confirmAction,
   cancelAction,
   exitAction
}) => {
   return (
      <div style={style.isNotRegistered}>
         <Typography style={style.titleOne}>
            <p> {title} </p>
            <img alt="" src={question} style={style.logo} />{' '}
         </Typography>
         <div style={style.detailsContainer}>
            <div style={style.messageUserisNotRegistred}> {message} </div>
            <div style={style.buttonContainer}>
               <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={style.exitButton}
                  fullWidth
                  onClick={() => exitAction()}
               >
                  SALIR
               </Button>

               <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={style.acceptButton}
                  fullWidth
                  onClick={() => confirmAction()}
               >
                  SI
               </Button>
               <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={style.cancelButton}
                  fullWidth
                  onClick={() => cancelAction()}
               >
                  CANCELAR SOLICITUD
               </Button>
            </div>
         </div>
      </div>
   )
}

export const ConfirmDeleteAssociateSnackbar = ({
   handleCancel,
   handleAccept
}) => {
   return (
      <div style={style.dialogContainer}>
         <div style={style.dialog}>
            <Typography style={style.titleOne}>
               <img alt="" src={cancel} style={style.dialogLogo} />
               <h3> CANCELAR </h3>
            </Typography>

            <div style={style.dialogMessage}>
               {' '}
               ¿Esta seguro que desea cancelar la solicitud y eliminar toda la
               información previamente registrada?{' '}
            </div>
            <div style={style.dialogMessage}>
               <Button
                  type="submit"
                  variant="outlined"
                  color="primary"
                  style={style.cancelDialogButton}
                  fullWidth
                  onClick={() => handleCancel()}
               >
                  CANCELAR
               </Button>
               <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={style.acceptDialogButton}
                  fullWidth
                  onClick={() => handleAccept()}
               >
                  ACEPTAR
               </Button>
            </div>
         </div>
      </div>
   )
}

export default UserNotRegistered
